import styled from 'styled-components';
import { Button } from 'reactstrap';




export const ButtonOther = styled(Button)`
  color: white;
  padding: 8px 20px;
  border-radius: 35px;
  border: none;
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size: 18px;
  height: 50px;
  background: linear-gradient(268.2deg, #002F59 -5.28%, #00488A 100%, #003F74 100%);

  margin-top: 10px;

  @media (max-width: 990px) {
    font-size: 16px;   /* Ajusta o tamanho da fonte */
    padding: 10px 15px; /* Ajusta o padding */
    margin-right: 10px;
   height: 80px;
    width: 100%;  /* Faz o botão ocupar toda a largura disponível */
    max-width: 350px; /* Limita a largura máxima */
  }
      @media (max-width: 400px) {
    font-size: 16px;   /* Ajusta o tamanho da fonte */
    padding: 10px 15px; /* Ajusta o padding */
    margin-right: 10px;

 
    width: 100%;  /* Faz o botão ocupar toda a largura disponível */
    max-width: 350px; /* Limita a largura máxima */
  }
`;

export const ButtonNext = styled(Button)`
  width: 80%;
  padding: 10px 25px;
  border-radius: 30px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  background-color: #25D366;
  margin-top: 20px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;

  &:hover {
    color: black;
    text-decoration: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
  }
`;

export const Container = styled.div`
  margin-top: 5px;
  padding: 20px;
`;

export const CenteredTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;
  margin-top: 20px;
`;

export const LeftAlignedTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin-top: 20px;
`;

export const ContactInfo = styled.div`
  display: flex;
  justify-content: left;
  margin-top: 10px;

  p {
    margin-bottom: 10px;
  }
`;
